import { generalFormErrors } from "@common/constants";
import { ISelectOption } from '@common/types';

export const extraInformationValidation = {
  maxLength: {
    value: 250,
    message: generalFormErrors.extraInformationLength,
  },
};

export const emcDisplayNameValidation = {
  maxLength: {
    value: 250,
    message: generalFormErrors.emcDisplayNameLength,
  },
};

export const medicinalProductNameValidation = {
  maxLength: {
    value: 250,
    message: generalFormErrors.medicinalProductNameLength,
  },
};

export const productFormValidation = {
  validate: (value: ISelectOption) =>
    !value?.label || value.label.length <= 4096 || generalFormErrors.productFormLength,
};
